import { render, staticRenderFns } from "./SaleUploads.vue?vue&type=template&id=2280df69&scoped=true&"
import script from "./SaleUploads.vue?vue&type=script&lang=js&"
export * from "./SaleUploads.vue?vue&type=script&lang=js&"
import style0 from "./SaleUploads.vue?vue&type=style&index=0&id=2280df69&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2280df69",
  null
  
)

export default component.exports